import { connect } from 'react-redux';
import * as url from 'url';
import { bindActionCreators } from 'redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { makeSearch } from '../../../state/search';
import { ISavePopupProps, SavePopup } from './index';

export type TDealType = 'sale' | 'rent';

export type TStateSavePopupProps = Pick<
  ISavePopupProps,
  | 'userEmail'
  | 'pageHeader'
  | 'jsonQuery'
  | 'dealType'
  | 'queryString'
  | 'isAuthenticated'
  | 'showPushNotification'
  | 'baseUrl'
  | 'currentSubdomain'
  | 'isPushEnabled'
  | 'metaHeader'
  | 'httpApi'
  | 'applicationServerKey'
  | 'notificationPermission'
>;
export type TDispatchSavePopupProps = Pick<ISavePopupProps, 'onOffersSearch'>;
export type TOwnProps = Pick<ISavePopupProps, 'onClose' | 'isAdvancedFiltersOpened'>;

export function mapStateToProps(state: IAppState): TStateSavePopupProps {
  const { config, httpApi, currentSubdomain } = state;
  const isPushEnabled = config.get<boolean>('push.enabled') || false;
  const baseUrl = config.get('push.browserUrl') as string;
  const applicationServerKey = config.get<string>('applicationServerKey') || '';
  let notificationPermission = 'default';
  let queryString = `?${state.results.queryString}`;

  if ('Notification' in window && currentSubdomain === 'www') {
    notificationPermission = Notification.permission;
  }

  if (state.filters.queryString) {
    let filtersQueryString = url.parse(state.filters.queryString);
    if (filtersQueryString.search) {
      queryString = filtersQueryString.search;
    }
  }

  return {
    userEmail: state.user.isAuthenticated ? state.user.email : null,
    pageHeader: state.results.seo.h1,
    dealType: (state.filters.jsonQuery._type.endsWith('sale') && 'sale') || ('rent' as TDealType),
    jsonQuery: state.filters.jsonQuery,
    isAuthenticated: state.user.isAuthenticated,
    queryString,
    showPushNotification: state.showPushNotification,
    metaHeader: state.filters.metaHeader,
    currentSubdomain: state.currentSubdomain,
    isPushEnabled,
    baseUrl,
    httpApi,
    applicationServerKey,
    notificationPermission,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TDispatchSavePopupProps {
  return {
    onOffersSearch: bindActionCreators(makeSearch, dispatch),
  };
}

export const SavePopupContainer = connect<TStateSavePopupProps, TDispatchSavePopupProps, TOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(SavePopup);
